import { SimpleSearchQueryField } from './simple-search-query-field';
export class NumberSearchQueryField extends SimpleSearchQueryField {
  constructor(searchOptions, value, defaultValue) {
    super(searchOptions, NumberSearchQueryField.parse(value), defaultValue);
  }
  getUrlParameterValue() {
    return this.isDefault() ? null : "".concat(this.internalValue);
  }
  static parse(value) {
    if (value == null) {
      return null;
    }
    var parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }
}